// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__pvHwG","description":"MealItem_description__GIevr","price":"MealItem_price__yQ9U7"};